import React from "react";
import { ChevronRight } from "lucide-react";

const HeroButton = ({
  href,
  onClick,
  children,
  variant = "primary",
  className = "",
}) => {
  const baseStyles =
    "w-full sm:w-auto flex items-center justify-center gap-2 rounded-full px-8 md:px-10 py-3.5 md:py-4 text-base md:text-lg font-semibold transition-all";

  const variants = {
    primary:
      "bg-[#0066ff] text-white hover:scale-105 shadow-xl shadow-blue-500/30 group relative overflow-hidden",
    secondary:
      "bg-slate-50/80 backdrop-blur-sm text-slate-800 hover:bg-white border border-slate-200/50 shadow-sm",
  };

  const Component = href ? "a" : "button";

  const primaryStyles =
    variant === "primary"
      ? {
          background:
            "radial-gradient(circle at center, #3b82f6 20%, #0066ff 100%)",
        }
      : {};

  return (
    <Component
      href={href}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      style={primaryStyles}
    >
      {variant === "primary" && (
        <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none blur-xl" />
      )}

      {children}

      {variant === "primary" && (
        <div className="flex items-center text-current">
          <ChevronRight className="h-4 w-4 opacity-40 group-hover:translate-x-0.5 transition-transform" />
          <ChevronRight className="h-5 w-5 opacity-70 -ml-2.5 group-hover:translate-x-0.5 transition-transform delay-75" />
          <ChevronRight className="h-6 w-6 opacity-100 -ml-3.5 group-hover:translate-x-0.5 transition-transform delay-150" />
        </div>
      )}

      {variant === "secondary" && (
        <span className="text-2xl leading-none -mt-1 ml-0.5">≈</span>
      )}
    </Component>
  );
};

export default HeroButton;
